module.exports = __webpack_public_path__ + "img/minus-white2.9307e30e.svg";